import { server_ip } from "../config";

export async function fetchRegistrationForms(token, filter, options , project=null) {
    try {
        const response = await fetch(`${server_ip}/api/registrationForms/fetch`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                filter,
                options,
                ...project?{project}:{}
            })
        });
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' };
    }
}

export async function fetchRegistrationFormById(token,id) {
    try {
        const response = await fetch(`${server_ip}/api/registrationForms/${id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            }
        });
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' };
    }
}

export async function insertRegistrationForm(data) {
    try {
        const response = await fetch(`${server_ip}/api/registrationForms`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ data })
        });
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' };
    }
}